import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';

interface UpdateCompanyInboundSettingsParams {
  companyId: string;
  isCareersPageEnabled: boolean;
}

export const useUpdateCompanyInboundSettingsMutation = () =>
  useMutation({
    mutationFn: async ({
      companyId,
      isCareersPageEnabled,
    }: UpdateCompanyInboundSettingsParams) => {
      const { data } = await fetchClient.PUT(endpoints.companyInbound, {
        params: { path: { id: companyId } },
        body: { isCareersPageEnabled },
      });
      return data;
    },
    onSuccess: (data, { companyId }) => {
      queryClient.setQueryData(companiesQueryKeys.inbound(companyId), data);
    },
  });
